export default __webpack_public_path__ + "static/media/laundry2-after-1024w.e4813596.avif";